export default __webpack_public_path__ + "static/media/light_blocking_box.bc2368fb.svg";